// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuListItem_container__1DiOY","wrapper":"MenuListItem_wrapper__2cKoY","upper_image":"MenuListItem_upper_image__Gvwsf","name":"MenuListItem_name__331hE"};